export default __webpack_public_path__ + "static/media/cctv.d1e3689d.png";